import { policies } from '../../../data/policies';

export default function Policies() {
  return (
    <section className="section policies" id="politicas">
      <div className="container policies__layout">
        <div className="policies__heading">
          <p className="eyebrow">Antes de tu cita</p>
          <h2 className="section-title">Acuerdos claros para cuidar nuestro tiempo.</h2>
        </div>
        <div className="policies__content">
          <div className="policies__list">
            {policies.map((policy, index) => (
              <article key={policy.title}>
                <span>0{index + 1}</span>
                <div><h3>{policy.title}</h3><p>{policy.description}</p></div>
              </article>
            ))}
          </div>
          <div className="policies__notice">
            <h4>¿Cuáles son los datos de transferencia para abonar?</h4>
            <p>
              Para resguardar la seguridad de la información, los datos bancarios se entregarán de forma privada por WhatsApp una vez que Poleth confirme la disponibilidad del horario solicitado para tu cita.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
